import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isPristine, isInvalid } from 'redux-form';
import Footer from '../components/Footer';
import { withFormName } from '../../../../common/hoc/withFormName';
import confirmModal from '../../../../common/confirmModal';
import withNotifications from '../../../../common/withNotifications';

export default compose(
  withFormName,
  withRouter,
  connect(
  (state, props) => ({
    pristine: isPristine(props.form)(state),
    invalid: isInvalid(props.form)(state),
  })),
  withNotifications,
  withProps(props => ({
    isDeletable: !!props.onDelete,
  })),
  withHandlers({
    handleDelete: props => async () => {
      if (!props.isDeletable) {
        return false;
      }

      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete tax',
        message: 'Are you sure you want to delete a tax?',
      });

      if (!confirmed) {
        return false;
      }

      return props.onDelete().then(() => {
        props.router.replace(props.baseUrl);
        props.addNotification({
          level: 'success',
          message: 'Tax is deleted.',
          title: 'Success',
        });
      });
    },
  }),
)(Footer);
